import { __decorate } from "tslib";
import { SerializableObject } from '@openhps/core';
import { activitystreams } from '../../terms';
import { Activity } from './Activity';
let ActivityAdd = class ActivityAdd extends Activity {
};
ActivityAdd = __decorate([
    SerializableObject({
        rdf: {
            type: activitystreams.Add,
        },
    })
], ActivityAdd);
export { ActivityAdd };
//# sourceMappingURL=ActivityAdd.js.map